// extracted by mini-css-extract-plugin
export default {"importActKC2TemplateModal":"ImportActKC2TemplateModal_importActKC2TemplateModal__aGL+H"};